export default "__VITE_ASSET__DQkDdD8j__"